import { palette } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';

export const useColorsAndSignatures = (): any[] => {
    const { t } = useTranslation();

    return [
        {
            signature: t('alphabetsignA'),
            background: palette.indigo[3],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignB'),
            background: palette.green[3],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignC'),
            background: palette.red[3],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignD'),
            background: palette.orange[3],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignE'),
            background: palette.purple[2],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignF'),
            background: palette.teal[2],
            fontColor: palette.jacarta[5],
        },
        {
            signature: t('alphabetsignG'),
            background: palette.blue[2],
            fontColor: palette.jacarta[5],
        },
    ];
};
